import { render, staticRenderFns } from "./stat.vue?vue&type=template&id=574de3f9&scoped=true&"
import script from "./stat.vue?vue&type=script&lang=js&"
export * from "./stat.vue?vue&type=script&lang=js&"
import style0 from "./stat.vue?vue&type=style&index=0&id=574de3f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574de3f9",
  null
  
)

export default component.exports